// src/components/AdminProtectedLayout.jsx
import { Outlet } from "react-router-dom";

const AdminProtectedLayout = () => {
  return (
    <div>
      {/* এখানে Admin Navbar / Sidebar থাকলে বসাও */}
      <Outlet />
    </div>
  );
};

export default AdminProtectedLayout;